import React from "react";
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import LeadCapturePopup from "@/components/LeadCapturePopup";
import ChatWidget from "@/components/ChatWidget";

const PublicLayout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col relative overflow-hidden">
            {/* Ambient orbs */}
            <div className="ambient-orb bg-brand-peach top-[10%] -left-24 w-[380px] h-[380px] animate-pulse-slow" />
            <div className="ambient-orb bg-brand-lavender top-[40%] -right-32 w-[420px] h-[420px] animate-pulse-slow" style={{ animationDelay: "2s" }} />
            <div className="ambient-orb bg-brand-mint bottom-[10%] left-1/3 w-[320px] h-[320px] animate-pulse-slow" style={{ animationDelay: "4s" }} />

            <Navigation />
            <main className="flex-1 relative z-10">{children}</main>
            <Footer />
            <LeadCapturePopup />
            <ChatWidget />
        </div>
    );
};

export default PublicLayout;
